const { fetchWithRetry } = require('./utils');

const fetchReceiptsByContestantId = async (contestantId) => {  
    try {  
        const response = await fetchWithRetry(`/api/receipts/contestant/${contestantId}`, {  
            method: 'GET',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
        });  
  
        if (!response.ok) {
            // Treat 404 (no receipts) as an empty list instead of an error
            if (response.status === 404) {
                return [];
            }
            throw new Error(`Error fetching receipts: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {  
        console.error('Error fetching receipts:', error);  
        throw error;  
    }  
};  

const fetchReceiptsByGroupId = async (groupId) => {  
    try {  
        const response = await fetchWithRetry(`/api/receipts/group/${groupId}`, {  
            method: 'GET',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
        });  
  
        if (!response.ok) {  
            throw new Error(`Error fetching receipts: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error fetching receipts:', error);  
        throw error;  
    }  
};  

const fetchReceiptById = async (receiptId) => {  
    try {  
        const response = await fetchWithRetry(`/api/receipts/${receiptId}`, {  
            method: 'GET',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
        });  
  
        if (!response.ok) {  
            throw new Error(`Error fetching receipt: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error fetching receipt:', error);  
        throw error;  
    }  
};  

const sendReceiptEmail = async (receiptId) => {  
    try {  
        const response = await fetchWithRetry(`/api/receipts/${receiptId}/send-email`, {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
        });  
  
        if (!response.ok) {  
            throw new Error(`Error sending receipt email: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error sending receipt email:', error);  
        throw error;  
    }  
};  

module.exports = {
    fetchReceiptsByContestantId,
    fetchReceiptsByGroupId,
    fetchReceiptById,
    sendReceiptEmail
}